import {
  Box,
  CircularProgress,
  Paper,
  Stack,
  SxProps,
  Typography,
} from "@mui/material";
import QuestionItem from "./QuestionItem";
import { useAppSelector } from "../../Redux/hooks";
import { useParams } from "react-router-dom";
import SurveyActions from "./Survey/SurveyActions";
import React from "react";
import LockStatus from "./LockStatus";

const responseContainer: SxProps = {
  flex: "1",
  minWidth: "1px",
};

const responseWrapper: SxProps = {
  width: "100%",
  p: 2,
  display: "flex",
  flexDirection: "column",
  borderRadius: "12px",
};

const responseWrapperHeader: SxProps = {
  p: 2,
  borderBottom: "1px solid",
  borderColor: "divider",
  m: -2,
  mb: 2,
};

const QuestionItemWrapper = () => {
  const { surveySlug } = useParams();
  // const scrollToRef = useRef<HTMLDivElement>(null);
  const selectedForm = useAppSelector((state) => state.response.selectedForm);
  const isFormLoading = useAppSelector((state) => state.response.isLoading);
  const questionList = useAppSelector((state) => state.response.questionList);

  // const [idFromQueries, setIdFromQueries] = useState<string>(
  //   sessionStorage.getItem("response-visit-question") || ""
  // );

  // useEffect(() => {
  //   if (idFromQueries && questionList?.length > 0) {
  //     setIdFromQueries("");
  //     scrollToRef.current?.scrollIntoView({ behavior: "smooth" });
  //   }
  // }, [questionList, idFromQueries]);

  return (
    <>
      {isFormLoading ? (
        <Stack
          sx={{ flex: 1, height: "100%" }}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <CircularProgress />
        </Stack>
      ) : (
        <>
          {questionList?.length > 0 && (
            <Box sx={responseContainer}>
              <Paper sx={responseWrapper}>
                <Stack sx={responseWrapperHeader} gap={1}>
                  <Typography fontWeight={600} variant="subtitle1">
                    {selectedForm?.name}
                  </Typography>
                  <Typography
                    variant="body1"
                    fontWeight={"regular"}
                    color="text.secondary"
                  >
                    {selectedForm?.phaseName}
                  </Typography>
                  <LockStatus selectedForm={selectedForm} />
                </Stack>

                {questionList
                  .filter(
                    (question) =>
                      question.isVisible && !question.properties.isHidden
                  )
                  .map((question, index) => (
                    <QuestionItem
                      // scrollToRef={
                      //   idFromQueries === question.id ? scrollToRef : null
                      // }
                      key={question.id}
                      index={index}
                      question={question}
                    />
                  ))}
              </Paper>

              {surveySlug && <SurveyActions />}
            </Box>
          )}

          {questionList?.length === 0 && (
            <Stack
              sx={{ flex: 1, height: "100%" }}
              justifyContent={"center"}
              alignItems={"center"}
            >
              <Typography sx={{ fontWeight: 600 }} color={"primary.main"}>
                No Questions Found
              </Typography>
            </Stack>
          )}
        </>
      )}
    </>
  );
};

export default React.memo(QuestionItemWrapper);
